export default [
  {
    name: 'follow-up-rules',
    path: '/settings/follow-up-rules',
    component: () => import(/* webpackChunkName: "follow-up-rules" */ './Index.vue'),
    meta: {
      showNavbar: true,
      title: 'Regras de Ações de Retorno',
      icon: 'dvr',
      label: 'Regras de Ações de Retorno',
      roles: ['Admin']
    }
  },
  {
    name: 'follow-up-rules-form',
    path: '/settings/follow-up-rules/:id?',
    component: () => import(/* webpackChunkName: "follow-up-rules" */ './Form.vue'),
    meta: {
      showNavbar: true,
      title: 'Regra de Ação de Retorno',
      icon: 'dvr',
      label: 'Regra de Ação de Retorno',
      roles: ['Admin']
    }
  }
]
